import ReactGA from "react-ga4";

import { envSwitch, isLocalhost } from "@connect/Env";

export default function initGoogleAnalytics() {
	const analyticsID = envSwitch("G-E51WQBPZ9Z", "G-CFDCJ03YFE", "G-W80EGG795L");

	ReactGA.initialize(analyticsID, { testMode: isLocalhost(), nonce: "70656fc9207d7a40ebb6befdab03ae042c53512404872bbdb7d87cb9f76fc0e7" });
}